import type { PropsWithChildren } from 'react';
import {
  AccountProvider, AnalyticsProvider, AnnouncerProvider, BusinessProvider, CustomerProvider,
  PlanPricingProvider, PresetProvider, QuoteProvider, ServiceProvider, SettingsProvider,
  StorageProvider, ThemeProvider, ToastProvider,
} from '@/providers';

/**
 * Provider order is dependency order:
 * storage → settings → theme → analytics → announcer → toast → business →
 * catalog → presets → customers → quotes.
 *
 * Analytics sits directly under settings because consent lives there, and above
 * everything that emits events.
 */
export function AppProviders({ children }: PropsWithChildren) {
  return (
    <StorageProvider>
      <SettingsProvider>
        <ThemeProvider>
          <AnalyticsProvider>
            <AnnouncerProvider>
              <ToastProvider>
                {/* Below toast (it reports sign-in failures) and below settings
                    (it writes the verified plan back into them). */}
                <AccountProvider>
                {/* Depends on nothing; fetches only when a price is shown. */}
                <PlanPricingProvider>
                <BusinessProvider>
                  <ServiceProvider>
                    <PresetProvider>
                      <CustomerProvider>
                        <QuoteProvider>{children}</QuoteProvider>
                      </CustomerProvider>
                    </PresetProvider>
                  </ServiceProvider>
                </BusinessProvider>
                </PlanPricingProvider>
                </AccountProvider>
              </ToastProvider>
            </AnnouncerProvider>
          </AnalyticsProvider>
        </ThemeProvider>
      </SettingsProvider>
    </StorageProvider>
  );
}
